const c = Object.freeze({
  ".co.uk": "GB",
  ".ca": "CA"
});
class m {
  provideCountryCode() {
    const o = window.location.hostname, e = Object.keys(c).filter(
      (t) => o.endsWith(t)
    );
    return e.length === 1 ? c[e[0]] : void 0;
  }
}
const d = "L", a = "loc", g = "US";
class f {
  countryCodeProviders;
  constructor(o) {
    this.countryCodeProviders = o;
  }
  provideCountryCode() {
    for (const o of this.countryCodeProviders) {
      const e = o.provideCountryCode();
      if (e !== void 0)
        return e;
    }
    return g;
  }
}
class v {
  getCookieByName(o) {
    const e = o + "=", n = decodeURIComponent(document.cookie).split(";");
    for (const s of n) {
      const i = s.trimStart();
      if (i.indexOf(e) === 0)
        return i.substring(e.length, i.length);
    }
  }
}
const u = Object.freeze({
  name: "United States",
  countryCode: "US",
  selectUrl: "select",
  canonicalUrl: "canonical",
  isMajorCountry: !0
});
class A {
  countryCodeProvider;
  constructor(o) {
    this.countryCodeProvider = o;
  }
  provideLocation(o) {
    const e = this.countryCodeProvider.provideCountryCode() ?? u.countryCode, t = o.filter(
      (n) => n.countryCode === e
    );
    return t.length === 1 ? t[0] : u;
  }
}
class w {
  constructor(o) {
    this.regionCodeProviders = o, this.regionCodeProviders = o;
  }
  provideRegionCode() {
    for (const o of this.regionCodeProviders) {
      const e = o.provideRegionCode();
      if (e !== void 0)
        return e;
    }
  }
}
class h {
  getSearchQueryParamByName(o) {
    const e = new URLSearchParams(window.location.search);
    if (e.has(o)) {
      const t = e.get(o);
      return t === null ? void 0 : t;
    }
  }
}
class l {
  constructor(o, e) {
    this.searchParamsAccessor = o, this.locationStringParser = e, this.searchParamsAccessor = o, this.locationStringParser = e;
  }
  provideRegionCode() {
    const o = this.searchParamsAccessor.getSearchQueryParamByName(a);
    return this.locationStringParser.parse(o).regionCode;
  }
  provideCountryCode() {
    const o = this.searchParamsAccessor.getSearchQueryParamByName(a);
    return this.locationStringParser.parse(o).countryCode;
  }
}
class C {
  constructor(o, e) {
    this.regionCode = o, this.countryCode = e, this.regionCode = o, this.countryCode = e;
  }
}
class P {
  parse(o) {
    return o === void 0 ? new C(void 0, void 0) : new C(
      this.getRegionCode(o),
      this.getCountryCode(o)
    );
  }
  getCountryCode(o) {
    return o.length >= 2 ? o.substring(0, 2) : void 0;
  }
  getRegionCode(o) {
    return o.length > 2 ? o.substring(2) : void 0;
  }
}
class y {
  constructor(o, e) {
    this.cookieAccessor = o, this.locationStringParser = e, this.cookieAccessor = o, this.locationStringParser = e;
  }
  provideRegionCode() {
    const o = this.cookieAccessor.getCookieByName(d);
    return this.locationStringParser.parse(o).regionCode;
  }
  provideCountryCode() {
    const o = this.cookieAccessor.getCookieByName(d);
    return this.locationStringParser.parse(o).countryCode;
  }
}
class k {
  constructor(o, e) {
    this.countryCode = o, this.languageCode = e;
  }
  getValue(o = "_") {
    return `${this.languageCode}${o}${this.countryCode}`;
  }
}
class O {
  constructor(o, e, t) {
    this.countryCodeProvider = o, this.languageCodeProvider = e, this.regionCodeProvider = t;
  }
  provideCurrent() {
    const o = this.getCountryCodeOrDefault(), e = this.regionCodeProvider.provideRegionCode();
    return this.provideForCountry(o, e);
  }
  provideCurrentInvariant() {
    const o = this.getCountryCodeOrDefault(), e = this.regionCodeProvider.provideRegionCode(), t = this.provideForCountry(o), n = this.provideForCountry(
      o,
      e
    );
    return t.getValue() !== n.getValue() ? t : void 0;
  }
  provideForCountry(o, e) {
    const t = this.languageCodeProvider.provideForCountry(
      o,
      e
    );
    return new k(o, t);
  }
  getCountryCodeOrDefault() {
    return this.countryCodeProvider.provideCountryCode() ?? g;
  }
}
class S {
  provideForCountry(o, e) {
    switch (o.toUpperCase()) {
      case "MX":
      case "ES":
        return "es";
      case "DE":
      case "AT":
        return "de";
      case "FR":
        return "fr";
      case "CA":
        return e?.toUpperCase() === "QC" ? "fr" : "en";
      default:
        return "en";
    }
  }
}
function p() {
  const r = new P(), o = new h(), e = new l(
    o,
    r
  ), t = new v(), n = new y(
    t,
    r
  ), s = new m();
  return new f([
    e,
    n,
    s
  ]);
}
function L() {
  const r = new P(), o = new h(), e = new l(
    o,
    r
  ), t = new v(), n = new y(
    t,
    r
  );
  return new w([
    e,
    n
  ]);
}
function R() {
  return new A(p());
}
function F() {
  const r = p(), o = new S(), e = L();
  return new O(
    r,
    o,
    e
  );
}
export {
  p as createCountryCodeProvider,
  F as createLocaleProvider,
  R as createLocationProvider,
  L as createRegionCodeProvider
};
//# sourceMappingURL=index.js.map
